import apiService from '@/services/api.service';

export default {
  async signUp(userData) {
    const response = await apiService.post('/users/register.json', userData);
    return response.data.data;
  },
  async getById(userId) {
    const response = await apiService.get(`/users/${userId}.json`);
    return { user: response.data.data, spaces: response.data.spaces };
  },
  async edit(user) {
    const response = await apiService.put(`/users/${user.id}.json`, user);
    return response.data.data;
  },
  async login(user) {
    const response = await apiService.post('/users/token.json', user);
    return { token: response.data.data, spaces: response.data.spaces };
  },
  async setPin(pin) {
    const response = await apiService.put('/users/pin.json', { pin });
    return response.data.data;
  },
  async registerDevice(deviceId) {
    const response = await apiService.post(
      '/device-sessions.json',
      deviceId === null ? {} : { device_id: deviceId },
    );
    return response.data.data;
  },
  async unlockSession(deviceSessionId, secret, pin) {
    const response = await apiService.post(
      '/users/pin.json',
      { device_session_id: deviceSessionId, secret, pin },
      {},
      { anonymous: true },
    );
    return response.data.data;
  },
  async forgetDeviceSession(deviceSessionId, secret) {
    await apiService.post(
      '/device-sessions/forget.json',
      { device_session_id: deviceSessionId, secret },
      {},
      { anonymous: true },
    );
  },
  async revokeDevice(deviceId) {
    await apiService.delete(`/device-sessions/device/${deviceId}.json`);
  },
  async enterSpace(vendorId) {
    const response = await apiService.post('/users/vendor.json', {
      vendor_id: vendorId,
    });
    return response.data.data;
  },
  async forgottenPassword(user) {
    const response = await apiService.post(
      '/users/forgottenPassword.json',
      user,
    );
    return response.data.data;
  },
  async resetPassword(user) {
    const response = await apiService.post('/users/resetPassword.json', user);
    return response.data.data;
  },
  async sendValidationEmail(email) {
    const response = await apiService.post('/users/new-email-validation.json', {
      email,
    });
    return response.data.data;
  },
  async validateEmail(validationData) {
    const response = await apiService.post(
      '/users/emailValidation.json',
      validationData,
    );
    return response.data.data;
  },
  async changeAccountLanguage(language) {
    const response = await apiService.post('users/locale/' + language);
    return response.data.data;
  },

  async checkField(query) {
    let queryText = '';
    Object.keys(query).forEach((q, index) => {
      if (query[q] && query[q] !== '') {
        if (index > 0) {
          queryText += '&';
        }
        queryText += `${q}=${query[q]}`;
      }
    });
    return (await apiService.get('users/check-field.json?' + queryText)).data
      .data;
  },
};
